import { Block } from '../../factories/types';
import { annotate } from '../../utils/annotate';
import { PdfSectionViewer } from './PdfSectionViewer';
import styles from './PdfSection.module.scss';

export const PdfSection: Block<'pdfSection'> = ({ data }) => {
	const { pdf, title } = data.fields;

	// Same asset-link narrowing as PdfViewerButton (components/button/PdfViewerButton.tsx)
	let url = pdf && 'fields' in pdf ? (pdf.fields.file?.url ?? '') : '';
	// Contentful returns protocol-relative asset URLs (see @bw/elements Image.tsx)
	if (url.startsWith('//')) url = 'https:' + url;
	const assetTitle = pdf && 'fields' in pdf ? pdf.fields.title : undefined;
	const heading = title ?? assetTitle ?? '';

	if (!url) return null;

	return (
		<section className={styles.pdfSection} {...annotate(data, '.')}>
			<div {...annotate(data, 'pdf')}>
				<PdfSectionViewer url={url} title={heading || 'PDF'} />
			</div>
		</section>
	);
};
